import core from "@/helpers/client";
const ServiceClientAppsService = {
  async headServiceClientAppAsync(clientAppsId, params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/services/${clientAppsId}/Service?no-cache=1`,
      params
    );
    return result;
  },
  async getServiceClientAppsAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/services?no-cache=1`,
      params
    );
    return result;
  },
  async getServiceClientAppAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/services/${id}?no-cache=1`
    );
    return result;
  },
  async createServiceClientAppAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/services`,
      model
    );
    return result;
  },
  async updateServiceClientAppAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/services/${id}`,
      model
    );
    return result;
  },
  async deleteServiceClientAppAsync(clientAppsId, id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/services/${clientAppsId}/services/${id}`
    );
    return result;
  },
};
export default ServiceClientAppsService;
